import SSpyDesktopHandler from './SSpyDesktopHandler'

export default SSpyDesktopHandler
